
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { type FeedbackStatus } from "@/types";

type FeedbackStatusFilterProps = {
  selectedStatuses: string[];
  setSelectedStatuses: (statuses: string[]) => void;
  companyStatuses?: any[];
};

const FeedbackStatusFilter = ({ 
  selectedStatuses, 
  setSelectedStatuses,
  companyStatuses = []
}: FeedbackStatusFilterProps) => {
  const handleStatusChange = (value: string) => {
    if (value === "all") {
      setSelectedStatuses([]);
    } else {
      // Replace current selection with the new status
      setSelectedStatuses([value]);
    }
  };

  // Determine the display value for the select component
  const value = selectedStatuses.length === 0 
    ? "all" 
    : selectedStatuses[0];

  return (
    <Select
      value={value}
      onValueChange={handleStatusChange}
    >
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Filter by status" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Statuses</SelectItem>
        {companyStatuses && companyStatuses.length > 0 ? (
          companyStatuses.map((status) => (
            <SelectItem key={status.id} value={status.id}>
              {status.name}
            </SelectItem>
          ))
        ) : (
          <>
            <SelectItem value="in_review">In Review</SelectItem>
            <SelectItem value="planned">Planned</SelectItem>
            <SelectItem value="in_progress">In Progress</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
            <SelectItem value="rejected">Rejected</SelectItem>
          </>
        )}
      </SelectContent>
    </Select>
  );
};

export default FeedbackStatusFilter;
